/* eslint-disable react-hooks/exhaustive-deps */
import {memo, useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import SelectRange, {FIELD_NAME} from '@adv-mt/mt-form-select-range'

const DEFAULT_ACTIVE_TAB = 2
const LEGACY_WRAPPER = 'legacy'

const FormLitres = ({
  initialSearch,
  isBasicContent = false,
  onChange,
  overlayContentRef,
  pageName = '',
  type,
  value = {},
  wrapper = LEGACY_WRAPPER
}) => {
  const {i18n, domain} = useContext(Context)

  const config = domain.get('config')
  const {litres, DEFAULT_LITRES, FILTER_NAMES} = config.get('search')

  const currentValue = {
    from: value.from || DEFAULT_LITRES,
    to: value.to || DEFAULT_LITRES
  }

  const options = useMemo(
    () =>
      litres.map(litresValue => ({
        id: litresValue,
        label: `${i18n.n(litresValue)} ${i18n.t('COMMON.UNIT_CC')}`
      })),
    []
  )

  return (
    <SelectRange
      defaultActiveTabIndex={DEFAULT_ACTIVE_TAB}
      fieldName={FILTER_NAMES.LITRES}
      formatterLabel={({value}) => `${i18n.n(value)} ${i18n.t('COMMON.UNIT_CC')}`}
      initialSearch={initialSearch}
      isBasicContent={isBasicContent}
      label={i18n.t('COMMON_LITRES')}
      onChange={onChange}
      options={{
        from: {
          name: FIELD_NAME.FROM,
          options
        },
        to: {
          name: FIELD_NAME.TO,
          options
        }
      }}
      overlayContentRef={overlayContentRef}
      pageName={pageName}
      type={type}
      value={currentValue}
      wrapper={wrapper}
    />
  )
}

FormLitres.displayName = 'FormLitres'
FormLitres.propTypes = {
  initialSearch: PropTypes.object,
  isBasicContent: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number
  }),
  wrapper: PropTypes.string
}

const FormLitresBasicContent = props => <FormLitres {...props} isBasicContent />
FormLitresBasicContent.displayName = 'FormLitresBasicContent'

const MemoFormLitres = memo(FormLitres)
const MemoFormLitresBasicContent = memo(FormLitresBasicContent)

export {MemoFormLitres as FormLitres, MemoFormLitresBasicContent as FormLitresBasicContent}

export default MemoFormLitres
